let language = {
    "3000601": "{{site}} 不支持货币: {{currencyCode}}",
    "3000697": "店铺货币({{storeCurrencyCode}})与店铺产品计价货币({{currencyCode}})不一致"
}

export { language }